import s from "./filter.module.css";
import { faEarthEurope } from "@fortawesome/pro-light-svg-icons";
import { faEarthEurope as earthSolid } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GipContext } from "state";
import { useContext } from "react";
import { useGTM } from "hooks";

export default function ResetMap() {
  const { resetMap } = useContext(GipContext);
  const { dataLayer } = useGTM();

  return (
    <div
      className={`${s.clickable} bg-gray-50 sm:border-r-gray-200 sm:border-r-1 hover:bg-primary-200 group w-[65px] sm:w-full`}
      onClick={(e) => {
        dataLayer.push({
          event: "cefic_gip_map.overview.click",
        });
        resetMap(e);
      }}
    >
      <p className={`${s.icon} group-hover:hidden`}>
        <FontAwesomeIcon icon={faEarthEurope} />
      </p>
      <p className={`${s.icon} hidden group-hover:inline-block`}>
        <FontAwesomeIcon icon={earthSolid} />
      </p>
      <p className={`${s.name}`}>Overview</p>
    </div>
  );
}
